import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../assets/css/AboutUs.css";

// Section imports
import Section1About from "../components/aboutSections/Section1About";
import Section2Mission from "../components/aboutSections/Section2Mission";
import Section3Values from "../components/aboutSections/Section3Values";
import Section4Why from "../components/aboutSections/Section4Why";
import Section5Ready from "../components/aboutSections/Section5Ready";

const AboutUs = () => {

  const appFrontendUrl = process.env.REACT_APP_URL;
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      <Helmet>
        <title>About Comparedly | Our Mission & Values</title>
        <meta name="description" content="Discover the story behind Comparedly. Learn about our mission to empower agencies with fast, accurate, and actionable social media competitor analysis." />
        <meta property="og:title" content="About Comparedly | Our Mission & Values" />
        <meta property="og:description" content="Discover the story behind Comparedly. Learn about our mission to empower agencies with fast, accurate, and actionable social media competitor analysis." />
      </Helmet>
      <Navbar />
      <div className="aboutus-container">
        <h1>About Comparedly</h1>
        <p>Learn more about our journey, our mission, and our values.</p>
        <Section1About />
        <Section2Mission />
        <Section3Values />
        <Section4Why />
        <Section5Ready />
        <strong>Get Started Today</strong>
        <p>
          <ul>
            <li>

              <button className="btn-primary full-width" onClick={() => window.location.href = `${appFrontendUrl}/auth/register`}>Start Your Free Trial</button>
              <strong> - Begin your 14-day free journey</strong>
            </li>
            <li>

              <button className="btn-secondary full-width" onClick={() => window.location.href = `${appFrontendUrl}/auth/demo`}>Request a demo</button>
              <strong> - Talk to our team</strong>
            </li>
          </ul>
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
